export default __webpack_public_path__ + "static/media/yo.ccd13427.jpg";